import { Reducer } from 'redux';
import { COST_CODES_SET_COST_CODES, IStoreCostCodes, IStoreCostCodesSetCostCodesAction } from '../costCodes';

export type ICostCodesActions = IStoreCostCodesSetCostCodesAction;

const initialState: IStoreCostCodes = {
  filters: {
    groupId: null,
    costCodeId: null,
    showArchived: false,
  },
  costCodes: [],
};

const costCodesReducers: Reducer<IStoreCostCodes, ICostCodesActions> = (state = initialState, action) => {
  switch (action.type) {
    case COST_CODES_SET_COST_CODES:
      return {
        ...state,
        costCodes: action.payload.costCodes,
      };
    default:
      return state;
  }
};

export default costCodesReducers;
